import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";

import image_team_blank6 from "../assets/images_team/blank_face.png";
import image_team_bh from "../assets/images_team/brandonh.jpeg";
const image_team_blank2 =
  "https://uploads.quarkly.io/643d8e6ebf72b300207d7233/images/14q.jpg?v=2023-04-17T21:07:08.834Z";
const image_team_blank3 =
  "https://uploads.quarkly.io/643d8e6ebf72b300207d7233/images/11q.jpg?v=2023-04-17T21:11:40.598Z";
const image_team_blank4 =
  "https://uploads.quarkly.io/643d8e6ebf72b300207d7233/images/1q.jpg?v=2023-04-17T21:06:57.036Z";
const image_team_blank5 =
  "https://uploads.quarkly.io/643d8e6ebf72b300207d7233/images/10q.jpg?v=2023-04-17T21:12:01.188Z";
// const image_team_blank6 =
//   "https://uploads.quarkly.io/643d8e6ebf72b300207d7233/images/8q.jpg?v=2023-04-17T21:11:29.178Z";


export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section padding="60px 0 40px 0" quarkly-title="Section_Team_Title">
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="column"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            Our Team
          </Text>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            Members and past alumni who have contributed to our work!
          </Text>
        </Box>
      </Section>
      <Section padding="90px 0 110px 0" quarkly-title="Section_Team_Content">
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="column"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            2024 - 2025 School Year
          </Text>
        </Box>
        <Box
          min-width="100px"
          min-height="100px"
          display="grid"
          margin="70px 0px 0px 0px"
          grid-template-columns="repeat(3, 1fr)"
          grid-template-rows="repeat(2, 1fr)"
          grid-gap="80px 70px"
          padding="0px 80px 0px 80px"
          lg-padding="0px 0 0px 0"
          lg-margin="50px 0px 0px 0px"
          lg-grid-gap="30px 40px"
          md-grid-template-columns="repeat(2, 1fr)"
          md-grid-template-rows="repeat(3, 1fr)"
          md-grid-gap="36px 25px"
          sm-grid-template-columns="1fr"
          sm-grid-gap="50px 0"
          flex-direction="row"
          align-items="center"
        >
          <LinkBox
            href="https://www.linkedin.com/in/brandon-h-abca/"
            target="_blank"
          >
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_bh}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_bh} 500w, ${image_team_bh} 800w, ${image_team_bh} 1080w, ${image_team_bh} 1600w, ${image_team_bh} 2000w, ${image_team_bh} 2600w, ${image_team_bh} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Brandon Hoynick
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Co-President / Greenhouse Lead
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank2}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank2} 500w, ${image_team_blank2} 800w, ${image_team_blank2} 1080w, ${image_team_blank2} 1600w, ${image_team_blank2} 2000w, ${image_team_blank2} 2600w, ${image_team_blank2} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                {/* Kara Ewert */}
                member name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                {/* Co-President */}
                role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank3}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank3} 500w, ${image_team_blank3} 800w, ${image_team_blank3} 1080w, ${image_team_blank3} 1600w, ${image_team_blank3} 2000w, ${image_team_blank3} 2600w, ${image_team_blank3} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                {/* Darren Paetz */}
                member name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                {/* Technical Advisor / Thermal Storage Lead */}
                role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank4}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank4} 500w, ${image_team_blank4} 800w, ${image_team_blank4} 1080w, ${image_team_blank4} 1600w, ${image_team_blank4} 2000w, ${image_team_blank4} 2600w, ${image_team_blank4} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The Role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank5}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank5} 500w, ${image_team_blank5} 800w, ${image_team_blank5} 1080w, ${image_team_blank5} 1600w, ${image_team_blank5} 2000w, ${image_team_blank5} 2600w, ${image_team_blank5} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The role
              </Text>
            </Box>
          </LinkBox>
        </Box>
      </Section>
      <Section padding="90px 0 110px 0" quarkly-title="Section_Team_Content">
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="column"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            Pre-2024 Years
          </Text>
        </Box>
        <Box
          min-width="100px"
          min-height="100px"
          display="grid"
          margin="70px 0px 0px 0px"
          grid-template-columns="repeat(3, 1fr)"
          grid-template-rows="repeat(2, 1fr)"
          grid-gap="80px 70px"
          padding="0px 80px 0px 80px"
          lg-padding="0px 0 0px 0"
          lg-margin="50px 0px 0px 0px"
          lg-grid-gap="30px 40px"
          md-grid-template-columns="repeat(2, 1fr)"
          md-grid-template-rows="repeat(3, 1fr)"
          md-grid-gap="36px 25px"
          sm-grid-template-columns="1fr"
          sm-grid-gap="50px 0"
          flex-direction="row"
          align-items="center"
        >
          <LinkBox
            href=""
            target="_blank"
          >
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
               member name
                {/* Larry Zhong, Lutfi-Hisham Muhammed, Aditya Shah, Matthew Danyluik?, */}
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                nom
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                nom
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The Role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The role
              </Text>
            </Box>
          </LinkBox>
          <LinkBox href="" target="">
            <Box
              min-width="100px"
              min-height="100px"
              display="flex"
              flex-direction="column"
              justify-self="center"
              sm-display="flex"
              sm-flex-direction="column"
              sm-align-items="center"
              align-items="center"
            >
              <Image
                src={image_team_blank6}
                display="block"
                width="250px"
                border-radius="50%"
                lg-width="180px"
                sm-width="100%"
                lg-max-width="100%"
                srcSet={`${image_team_blank6} 500w, ${image_team_blank6} 800w, ${image_team_blank6} 1080w, ${image_team_blank6} 1600w, ${image_team_blank6} 2000w, ${image_team_blank6} 2600w, ${image_team_blank6} 3200w`}
                sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
              />
              <Text
                margin="8px 0px 0px 0px"
                color="--green"
                font="27px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                Member Name
              </Text>
              <Text
                margin="8px 0px 0px 0px"
                color="--light"
                font="18px --fontFamily-googleRubik"
                text-align="center"
                height="27px"
                width="100%"
              >
                The role
              </Text>
            </Box>
          </LinkBox>
        </Box>
      </Section>
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
